module.exports = __webpack_public_path__ + "static/media/400060_02.9d65cdba.png";